import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { LoginLibService } from '@ebootis/login';
import { Observable, Observer } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginGuardService  {

  constructor(
    private m_router: Router,
    private m_loginLibService: LoginLibService
  ) { }

  canActivate(p_route: ActivatedRouteSnapshot, p_state: RouterStateSnapshot): Observable<boolean> {
    return new Observable((observer: Observer<boolean>) => {
      if (!this.m_loginLibService.LoggedIn) {
        observer.next(true);
        observer.complete();
      } else {
        observer.next(false);
        observer.complete();
        this.m_router.navigate(['uebersicht']);
      }
    });
  }
}
